<template>
  <div>
    <!--  <div ref="bbox" style="position: fixed; margin:340px -200px;z-index:666;"> -->
    <div :style="{display:fullScreenTag?'none':'block'}">
      <Collapse size="large" simple v-model="workBookOptions">
        <Panel name="1" size="large" class="cpllapse-panel-title">
          工作薄选项
          <div slot="content">
            <Form :model="formItem" :label-width="80">
              <Row>
                <Col span="5">
                <FormItem label="标题">
                  <Input v-model="formItem.inputfilename" class="common-width" placeholder="请输入工作薄标题"></Input>
                </FormItem>
                </Col>
              </Row>
              <Row>
                <Col span="6">
                <FormItem label="标签">
                  <!-- <Select v-model="formItem.industryselected" multiple class="common-width" placeholder="行业">
                    <Option v-for="item in industry" :value="item.value" :key="item.value">{{ item.label }}</Option>
                  </Select> -->
                  <SingleSelect class="common-width" ref="industrySelector" @onClearText="onIndustryClearText" @tag-Select="getIndustrySelection"></SingleSelect>
                </FormItem>
                <FormItem label="">
                  <!--  <Select v-model="formItem.taxcategoryselected" multiple class="common-width" placeholder="税种">
                    <Option v-for="item in cList" :value="item.value" :key="item.value">{{ item.label }}</Option>
                  </Select> -->
                  <SingleSelect class="common-width" ref="taxSelector" @onClearText="onTaxClearText" @tag-Select="getTaxSelection"></SingleSelect>
                </FormItem>
                <FormItem label="">
                  <Input v-model="formItem.inputothers" class="common-width" placeholder="请输入自定义标签"></Input>
                </FormItem>
                </Col>
              </Row>
              <FormItem label="关键词">
                <Input v-model="formItem.keyword" class="common-width" placeholder="请输入关键词"></Input>
              </FormItem>
            </Form>
          </div>
        </Panel>
      </Collapse>
      <br />
    </div>
    <SearchEngine ref="searchResult"></SearchEngine>
    <!--   <Divider orientation="left">以下是工作薄正文</Divider> -->
    <!--  <div>&nbsp;</div> -->
    <div>
      <!--  <mavon-editor v-model="value" :subfield="false" :toolbars="toolbars" @fullScreen="go" @save="save" :style="{zIndex:5,position:'relative',height:fullScreenTag?'46.5vh':'30vh'}" /> -->
      <Input v-model="value" type="textarea" :autosize="{minRows: 14,maxRows: 20}" placeholder="请输入内容..." />
    </div>
    <br />
    <Button :icon="relatedButtonSelected?'ios-link':''" :type="relatedButtonSelected?'primary':'dashed'" @click="relatedfile">{{relatedButtonSelected?'隐藏':'显示'}}附件({{relatedFileLength}}个)</Button>&nbsp;&nbsp;
    <Icon type="ios-checkmark-circle" size="24" :style="{display:relatedButtonSelected?'inline-block':'none'}" color="lightgreen" />
    <p>&nbsp;</p>
    <Collapse v-model="relatedValue" size="large" :style="{display:relatedButtonSelected?'block':'none'}">
      <Panel name="1" size="large" class="cpllapse-panel-title" :style="{display:historyPannelDisp?'block':'none'}">
        历史附件
        <div slot="content">
          <RelatedFile ref="relatedHistoryFile" @u-remove-row="removeHistoryrow"></RelatedFile>
        </div>
      </Panel>
      <Panel name="2" size="large" class="cpllapse-panel-title">
        当前附件 (<font color="red">选中文件将作为工作簿附件提交</font>)
        <div slot="content" style="height: 300px;overflow-y: auto;">
          <RelatedFile ref="relatedFileRead"></RelatedFile>
        </div>
      </Panel>
      <!--       <Panel name="3" size="large" class="cpllapse-panel-title" :style="{display:addPannelDisp?'block':'none'}">
        新增相关附件
        <div slot="content">
          <RelatedFile ref="relatedNewReadFile"></RelatedFile>
        </div>
      </Panel> -->
    </Collapse>
    <br :style="{display:relatedButtonSelected?'block':'none'}" />
    <div style="display: inline;">
      <Button type="success" size="large" :style="{width:buttonWidth}" @click="btnSave">保存</Button>
      <Button type="primary" size="large" :style="{width:buttonWidth}" @click="btnSubmit">提交</Button>
      <Alert type="warning" :style="{display:showSubmitNotice?'inline-block':'none'}" show-icon>{{sumitLeftDesc}}</Alert>
    </div>
    <!-- <Row>
      <Col span="5">
       <Button type="success" size="large" :style="{width:buttonWidth}" @click="btnSave">保存</Button>
    <Button type="primary" size="large" :style="{width:buttonWidth}" @click="btnSubmit">提交</Button>
    </Col>
     <Col span="19">
     <Alert type="warning" :style="{display:showSubmitNotice?'block':'none',width:'300px'}"  show-icon>123{{sumitLeftDesc}}</Alert>
    </Col>
    </Row> -->
    <Modal v-model="modalPages" width="450" :mask-closable="false" :z-index="1501">
      <p slot="header" style="color:#2b85e4;text-align:center;font-size:16px;">
        <Icon type="ios-information-circle"></Icon>
        <span>请选择您要下载的文档</span>
      </p>
      <div style="text-align:center;height: 400px;overflow: auto;">
        <!--  <DocManage ref="DocMng"></DocManage> -->
        <!-- <RelatedFile ref="relatedFileRead"></RelatedFile> -->
        <RelatedFile ref="downLoadfiles" @bindcomplete="dataBindOk"></RelatedFile>
      </div>
      <div slot="footer">
        <Button type="text" size="large" @click="downLoadCancel">取消</Button>
        <Button type="primary" size="large" @click="down">确定</Button>
      </div>
    </Modal>
  </div>
</template>
<script>
// import SelectData from '../../../static/api/selectData.json'
import RelatedFile from './workbook_related_table.vue'
import SearchEngine from '../common/doc/drawerpage.vue'
import TreeSingleselect from '../common/tree-single-select.vue'
import { base } from '../common/util'
import store from '../../store'
import { mapState, mapMutations, mapActions, mapGetters } from 'vuex'
import { uuid } from 'vue-uuid'
import constJson from '../../api/common/constjson.js'
let constJ = new constJson()
export default {
  name: 'workbook_editer',
  data() {
    return {
      formItem: {
        inputfilename: '',
        inputothers: '',
        industryselected: [],
        taxcategoryselected: [],
        keyword: '',
      },
      industry: {}, //SelectData.industry,
      cList: {}, //SelectData.taxcategory,
      value: "",
      relatedButtonSelected: false,
      relatedValue: [2],
      // addPannelDisp: false,
      historyPannelDisp: false,
      relatedFileLength: 0,
      sumitLeftDesc: "",
      showSubmitNotice: false,
      editorState: 0, //0=default,1=new,2=edit
      buttonWidth: '150px',
      currentBookId: 0,
      currentBookGuid: '',
      workBookOptions: [],
      // current
      toolbars: {
        bold: true, // 粗体
        italic: true, // 斜体
        //header: true, // 标题
        // underline: true, // 下划线
        // strikethrough: true, // 中划线
        // mark: true, // 标记
        // superscript: true, // 上角标
        // subscript: true, // 下角标
        quote: true, // 引用
        // ol: true, // 有序列表
        // ul: true, // 无序列表
        // link: true, // 链接
        //imagelink: true, // 图片链接
        code: true, // code
        //table: true, // 表格
        fullscreen: true, // 全屏编辑
        //readmodel: true, // 沉浸式阅读
        //htmlcode: true, // 展示html源码
        //help: true, // 帮助
        /* 1.3.5 */
        undo: true, // 上一步
        redo: true, // 下一步
        trash: true, // 清空
        // save: true, // 保存（触发events中的save事件）
        /* 1.4.2 */
        //navigation: true, // 导航目录
        /* 2.1.8 */
        alignleft: true, // 左对齐
        aligncenter: true, // 居中
        alignright: true, // 右对齐
        /* 2.2.1 */
        subfield: true, // 单双栏模式
        // preview: true, // 预览
      },
      modalPages: false,
      fullScreenTag: false, //控制mavon的position和height,控制工作薄选项的隐藏和显示
    }
  },
  mounted() {
    this.bindIndustry()
    this.bindTax()
    //window.addEventListener('scroll', this.handleScroll, true);
  },
  //workBookSubmitLeft在此页面初始化时并未从vuex种取到
  computed: {
    ...mapGetters(['readFileLength', 'historyFileLength', 'workBookSubmitLeft', 'sta', 'industryData', 'taxesData'])
  },
  components: {
    'RelatedFile': RelatedFile,
    'SearchEngine': SearchEngine,
    'SingleSelect': TreeSingleselect,
  },
  methods: {
    save(content) {
      //console.log(content)
    },
    btnSave() {
      if (this.formItem.inputfilename === "") {
        this.$Message.error("请输入工作簿标题");
        return
      }
      this.setContentStatefalse()
      var readfiles = [],
        histryfiles = []
      var items = store.state.user.workbook.readfilesSelected
      if (items != undefined && items.length > 0) {
        for (let i = 0; i < items.length; i++) {
          var fileid = parseInt(items[i].fileid)
          readfiles.push(fileid)
        }
      }

      var hisfiles = store.state.user.workbook.historyfiles
      if (hisfiles != undefined && hisfiles.length > 0) {
        for (let i = 0; i < hisfiles.length; i++) {
          var fileid = parseInt(hisfiles[i].fileid)
          histryfiles.push(fileid)
        }
      }


      let _industry = this.formItem.industryselected
      let _taxes = this.formItem.taxcategoryselected
      let book = {
        bookid: this.currentBookId,
        bookguid: this.currentBookGuid,
        title: this.formItem.inputfilename,
        industrycode: _industry === undefined || _industry.length === 0 ? this.$refs.industrySelector.value : this.formItem.industryselected.id,
        taxcode: this.formItem.taxcategoryselected === undefined || _taxes.length === 0 ? this.$refs.taxSelector.value : this.formItem.taxcategoryselected.id,
        customlabel: this.formItem.inputothers,
        keyword: this.formItem.keyword,
        contenttext: base.utf8_to_b64(this.value),
        historyappendix: histryfiles,
        newappendix: readfiles,
      }
      console.log(book)
      // console.log(readfiles)
      this.postSaveData(book)


      //let a = base.utf8_to_b64(this.value)
      // let b = base.b64_to_utf8(a)
      // console.log("a：" + a)
      // console.log("b:" + b)
    },
    btnSubmit() {
      if (this.formItem.inputfilename === "") {
        this.$Message.error("请输入工作簿标题");
        return
      }
      let leftCount = store.state.user.workbook.submitLeft
      if (leftCount === 0 || leftCount < 0) {
        this.$Modal.warning({
          title: "温馨提示",
          content: "您今日的剩余的提交次数已用完,请明日尝试",
          onOk: function() {
            return
          },
        })
      } else if (leftCount === 1) {
        var that = this
        this.$Modal.confirm({
          title: "温馨提示",
          content: "您今日的剩余的提交次数：1次",
          okText: "确认并提交",
          onOk: function() {
            that.submit()
          },
          onCancel: function() {
            return
          }
        })
      } else {
        this.submit()
      }
    },
    submit() {
      this.leftSumit()
      //this.setContentStatefalse()
      this.clearReadFiles()
      // console.log("child value:"+this.$refs.taxSelector.value)
      // console.log(this.formItem.industryselected)
      var readfiles = [],
        histryfiles = []
      var items = store.state.user.workbook.readfilesSelected
      if (items != undefined && items.length > 0) {
        for (let i = 0; i < items.length; i++) {
          var fileid = parseInt(items[i].fileid)
          readfiles.push(fileid)
        }
      }

      var hisfiles = store.state.user.workbook.historyfiles
      if (hisfiles != undefined && hisfiles.length > 0) {
        for (let i = 0; i < hisfiles.length; i++) {
          var fileid = parseInt(hisfiles[i].fileid)
          histryfiles.push(fileid)
        }
      }

      let _industry = this.formItem.industryselected
      let _taxes = this.formItem.taxcategoryselected
      let book = {
        bookid: this.currentBookId,
        bookguid: this.currentBookGuid,
        title: this.formItem.inputfilename,
        industrycode: _industry === undefined || _industry.length === 0 ? this.$refs.industrySelector.value : this.formItem.industryselected.id,
        taxcode: this.formItem.taxcategoryselected === undefined || _taxes.length === 0 ? this.$refs.taxSelector.value : this.formItem.taxcategoryselected.id,
        customlabel: this.formItem.inputothers,
        keyword: this.formItem.keyword,
        contenttext: base.utf8_to_b64(this.value),
        historyappendix: histryfiles,
        newappendix: readfiles,
      }
      console.log(book)
      // console.log(this.formItem)
      // console.log(this.value)
      //console.log(store.state.user.workbook)
      this.postCommitData(book)
      //this.postData(book)

    },
    postCommitData(book) {
      constJ.workBookCommit(book).then(res => {
        if (res.rtncode === 1) {
          if (res.rltcode === 1) {

            this.$Message.success('提交成功!')
            this.$emit('submitOk')
          } else {
            this.$Message.error(res.rltdesc);
            console.log("res.rltdesc:" + res.rltdesc)
            return
          }
        } else {
          this.$Message.error(res.rtndesc);
          console.log(".rtndesc:" + res.rtndesc)
          return
        }
      })
    },
    postSaveData(book) {
      constJ.workBookSave(book).then(res => {
        // console.log(res)
        if (res.rtncode === 1) {
          if (res.rltcode === 1) {
            this.currentBookId = res.newbookid
            this.currentBookGuid = res.bookguid
            this.$Message.success('保存成功!')
            this.$emit('workBookSave')
          } else {
            this.$Message.error(res.rltdesc);
            console.log("res.rltdesc:" + res.rltdesc)
            return
          }
        } else {
          this.$Message.error(res.rtndesc);
          console.log(".rtndesc:" + res.rtndesc)
          return
        }
      })
    },


    loadText(txt) {
      if (txt !== '') {
        // var t = txt.text
        //console.log(txt)
        let text = base.b64_to_utf8(txt)
        this.value = text
      } else {
        this.value = ""
      }
    },
    setContentStatefalse() {
      if (store.state.user.workbook.isContentChanged) {
        console.log("set workbook false")
        store.commit('setWorkBook', false)
      }
    },
    clearReadFiles() {
      store.commit('clearBookRead')
    },
    leftSumit() {
      store.commit('workBookSubmit')
      this.getSubmitLeft()
    },
    getSubmitLeft() {
      let leftCount = store.state.user.workbook.submitLeft
      if (leftCount < 5 && leftCount >= 0) {
        this.sumitLeftDesc = "(剩余提交次数:" + leftCount + "次)"
        this.showSubmitNotice = true
      }
    },
    relatedfile() {
      this.relatedButtonSelected = !this.relatedButtonSelected
      if (this.editorState === 1) {
        this.relatedValue = [2]
      } else if (this.editorState === 2) {
        this.relatedValue = [1, 2]
        this.bindHistoryFiles()
      }
      this.bindFiles()
      //this.bindDownLoadFiles() //绑定下载文件
      // this.selectAllFiles(true)
      // console.log(store.state.user.workbook.readfiles)

    },
    bindDownLoadFiles() {
      //downLoadfiles
      //this.$refs.downLoadfiles.bindFiles()
    },
    bindFiles() {
      this.$refs.relatedFileRead.bindFiles()
    },
    selectAllFiles(v) {
      this.$refs.relatedFileRead.handleSelectAll(v)
    },
    bindHistoryFiles() {
      let histories = store.state.user.workbook.historyfiles
      // console.log(histories)
      this.$refs.relatedHistoryFile.bindData(histories, 2)
    },
    addReadBook() {
      // this.addPannelDisp = true
      this.relatedValue = [2, 3]
      this.$emit('on-workbook-newreadfile')
    },
    mockBookHistoryFiles(historyfiles) {
      this.historyPannelDisp = true
      // var files = [{
      //     fileid: "fileidxxxx0012301223",
      //     filename: '国务院办公厅进一步整顿和规范成品油市场秩序意见的通知09981',
      //     index: 0,
      //     key: uuid.v1()
      //   },
      //   {
      //     fileid: "fileidxxxx0012301225",
      //     filename: '原产货物适用原产地规则操作管理程序规定有关事宜881109',
      //     index: 0,
      //     key: uuid.v1()
      //   }
      // ]
      var files = []
      if (historyfiles !== undefined && historyfiles.length > 0) {
        for (let i = 0; i < historyfiles.length; i++) {
          var hf = {
            fileid: historyfiles[i].docid,
            filename: historyfiles[i].h1,
            index: 0,
            key: uuid.v1()
          }
          files.push(hf)
        }
      }
      // console.log('tempfiles...')
      // console.log(files)
      store.commit('setBookHistoryFiles', files)
      console.log(store.state.user.workbook.historyfiles)
      //this.refreshRelatedFiles()
      this.bindHistoryFiles()
    },
    refreshRelatedFiles() {
      //console.log(this.editorState)
      let f_length = 0
      if (this.editorState === 1) {
        this.historyPannelDisp = false
        f_length = this.readFileLength
      } else if (this.editorState === 2) {
        f_length = this.historyFileLength + this.readFileLength

      } else {
        f_length = 0
      }
      return f_length
    },
    removeHistoryrow(files) {
      this.relatedFileLength = this.refreshRelatedFiles()
    },
    openEngine() {
      this.$refs.searchResult.showlayer(["preferential", "filename"], 720);
    },
    handleScroll() {
      // var sTop=document.body.scrollTop+document.documentElement.scrollTop;
      // window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
      //console.log(this.$refs.bbox)
    },
    showDownLoadFiles(row) {
      this.modalPages = true
      //console.log(row)
      //console.log("row.bookid:"+row.bookid)
      this.bindDownLoadFiles(row[0].bookid)
      //this.$refs.downLoadfiles.handleSelectAll(true)
    },
    dataBindOk() {
      //this.$refs.downLoadfiles.handleSelectAll(true)
    },
    bindDownLoadFiles(bookid) {
      console.log("bookid:" + bookid)
      constJ.getWorkBookDownLoadList(bookid).then(res => {
        //console.log(res)
        var files = []
        if (res.rtncode === 1) {
          if (res.rltcode === 1) {
            //console.log(res)
            //var file = { fileid: fileid, filename: fname, index: 0, key: uuid.v1(), }
            let items = res.tbls[0].items
            if (items !== undefined && items.length > 0) {
              for (let i = 0; i < items.length; i++) {
                var file = {
                  fileid: items[i].docid,
                  filename: items[i].h1,
                  bookid: items[i].bookid,
                  index: 0,
                  key: uuid.v1(),
                }
                files.push(file)
              }
              this.$refs.downLoadfiles.bindDownLoadFiles(files)
              //this.$refs.downLoadfiles.handleSelectAll(true)
            }
          } else {

          }
        } else {

        }

      })
    },
    go() {
      this.fullScreenTag = !this.fullScreenTag
      // console.log("fullScreenTag=true")
      this.$emit('onFullScreen', this.fullScreenTag)
      if (this.fullScreenTag) {
        this.relatedValue = []
      }
    },
    down() {
      console.log("down...")
      console.log(this.$refs.downLoadfiles.getSelected())
      var items = this.$refs.downLoadfiles.getSelected()
      var docs = []
      var bid = 0;
      if (items !== undefined && items.length > 0) {
        for (let i = 0; i < items.length; i++) {
          var docid = parseInt(items[i].fileid)
          bid = items[i].bookid
          docs.push(docid)
        }
        var book = {
          bookid: bid,
          docid: docs
        }
        console.log("req book...")
        console.log(book)
        constJ.reqPostDownLoadFile(book)

      }
      this.modalPages = false
      this.$Message.success('下载中,请稍后...');
    },
    downLoadCancel() {
      this.modalPages = false
    },
    propDataInit(data, placeholder, searchable) {
      var a = {}
      a.data = data
      a.placeholder = placeholder
      a.searchable = searchable
      return a
    },
    bindIndustry() {
      let obj = this.propDataInit(this.sta.initData.industry, "行业", false)
      this.industry = obj
      this.$refs.industrySelector.bindData(obj)
    },
    onIndustryClearText() {
      //console.log("clear")
      this.formItem.industryselected = {}
    },
    getIndustrySelection(node) {
      this.formItem.industryselected = node
      // console.log(this.formItem.industryselected)

    },
    onTaxClearText() {
      this.formItem.taxcategoryselected = {}
    },
    getTaxSelection(node) {
      this.formItem.taxcategoryselected = node
      // console.log(this.formItem.taxcategoryselected.id)
    },
    bindTax() {
      let obj = this.propDataInit(this.sta.initData.taxes, "税种", false)
      this.clist = obj
      this.$refs.taxSelector.bindData(obj)
    },
    formDataFill(items) {
      //console.log(items)
      var industry = [],
        taxes = []
      // industry.push(items.industrycode)
      // taxes.push(items.taxcode)

      //console.log(industry)
      this.formItem.inputfilename = items.title
      this.formItem.inputothers = items.customlabel
      this.formItem.keyword = items.keyword
      this.$refs.industrySelector.setShowValue(items.industrycode)
      this.$refs.taxSelector.setShowValue(items.taxcode)
      // this.industryValue =industry
      // this.taxesValue=taxes
      //this.formItem.taxcategoryselected=['"'+items.taxcode+'"']
      //console.log(this.industryValue)
      //this.value=items.contenttext
      //console.log(this.industryValue,this.taxesValue)
    },
    clearFromData() {
      this.formItem.inputfilename = ''
      this.formItem.inputothers = ''
      this.formItem.keyword = ''
      this.$refs.industrySelector.setShowValue(null)
      this.$refs.taxSelector.setShowValue(null)
      //this.setContentStatefalse()

    },
    setWorkbookId(book) {
      this.currentBookId = book.bookId
      this.currentBookGuid = book.bookGuid
    },
    setWrokBookOptions(value) {
      this.workBookOptions = value
    }

  },
  watch: {
    value: function() {

      if (!store.state.user.workbook.isContentChanged) {
        if (this.value !== '') {
          console.log("set workbook true")
          store.commit('setWorkBook', true)
        }

      }

    },
    readFileLength: function() {
      //this.relatedFileLength=this.readFileLength
      this.relatedFileLength = this.refreshRelatedFiles()
      this.bindFiles()
    },
    historyFileLength: function() {
      this.relatedFileLength = this.refreshRelatedFiles()
      this.bindHistoryFiles()
    },
    editorState: function() {
      this.relatedFileLength = this.refreshRelatedFiles()
    },
    industryData: function() {
      this.bindIndustry()
    },
    taxesData: function() {
      this.bindTax()
    },
  },

}

</script>
<style lang="less" scoped>
.common-width {
  width: 400px;
}

.mavon-max {
  position: absolute;
  left: 0px;
  top: 0px;
  width: 100%;
}

.mavon-default {
  position: relative;
}

</style>
